<template>
  <section id="howitworks" class="section how-it-works">
    <div class="section-container reveal">
      <div class="section-head">
        <div>
          <span class="section-label">Cara Kerja</span>
          <h2 class="section-title">
            Wujudkan proyek Anda dengan proses yang jelas dan cepat
          </h2>
        </div>
      </div>

      <div class="steps-grid">
        <article v-for="(step, index) in steps" :key="step.title" class="step-card card">
          <div class="step-media">
            <img :src="step.image" :alt="step.title" loading="lazy" decoding="async" />
          </div>

          <div class="step-content">
            <span class="step-index">{{ formatIndex(index + 1) }}</span>
            <h3>{{ step.title }}</h3>
            <p>{{ step.description }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import pendahuluan from "@/assets/pendahuluan1.png";
import negosiasi from "@/assets/negosiasi2.png";
import perancangan from "@/assets/perancangan3.png";
import proses from "@/assets/proses4.png";
import laporan from "@/assets/laporan5.png";

export default {
  name: "HowItWorks",
  data() {
    return {
      steps: [
        {
          title: "Pendahuluan",
          description:
            "Kami memulai dengan meeting untuk memahami tujuan aplikasi, kebutuhan bisnis, serta teknologi yang paling tepat untuk digunakan.",
          image: pendahuluan,
        },
        {
          title: "Negosiasi",
          description:
            "Kami menyusun ruang lingkup, kontrak, serta skema pembayaran. Proyek dimulai setelah kedua pihak menyepakati rencana kerja.",
          image: negosiasi,
        },
        {
          title: "Perancangan & Strategi",
          description:
            "Tim kami merancang desain, struktur sistem, dan strategi implementasi. Konsep dipresentasikan untuk memperoleh masukan Anda.",
          image: perancangan,
        },
        {
          title: "Eksekusi Proyek",
          description:
            "Tahap pengembangan berjalan dengan update rutin sehingga Anda dapat memantau progres secara transparan dan terukur.",
          image: proses,
        },
        {
          title: "Laporan & Evaluasi",
          description:
            "Setelah implementasi, kami menyiapkan laporan akhir dan sesi handover agar tim Anda siap menggunakan sistem secara optimal.",
          image: laporan,
        },
      ],
    };
  },
  methods: {
    formatIndex(value) {
      return String(value).padStart(2, "0");
    },
  },
};
</script>

<style scoped>
.how-it-works {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.55), rgba(239, 244, 252, 0.7));
}

.steps-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}

.step-card {
  flex: 0 1 calc((100% - 16px) / 2);
  min-width: 0;
  overflow: hidden;
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  min-height: 244px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  background: #fff;
}

.step-media {
  position: relative;
  background: linear-gradient(145deg, #ecf3ff, #f9fbff);
}

.step-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.step-content {
  padding: 20px 22px;
}

.step-index {
  font-family: "Sora", sans-serif;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--primary);
  letter-spacing: 0.09em;
}

.step-content h3 {
  margin-top: 10px;
  font-size: 1.18rem;
  color: var(--text);
}

.step-content p {
  margin-top: 10px;
  font-size: 0.95rem;
}

@media (max-width: 1020px) {
  .step-card {
    grid-template-columns: 1fr;
    min-height: 0;
  }

  .step-media {
    height: 200px;
  }
}

@media (max-width: 860px) {
  .step-card {
    flex-basis: calc((100% - 16px) / 2);
  }
}

@media (max-width: 760px) {
  .steps-grid {
    gap: 10px;
  }

  .step-card {
    flex-basis: calc((100% - 20px) / 3);
  }

  .step-media {
    height: 88px;
  }

  .step-content {
    padding: 8px 8px 10px;
  }

  .step-index {
    font-size: 0.58rem;
    letter-spacing: 0.05em;
  }

  .step-content h3 {
    margin-top: 5px;
    font-size: 0.68rem;
    line-height: 1.3;
  }

  .step-content p {
    margin-top: 4px;
    font-size: 0.56rem;
    line-height: 1.4;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
}

@media (max-width: 420px) {
  .step-card {
    flex-basis: calc((100% - 10px) / 2);
  }

  .step-media {
    height: 104px;
  }

  .step-content h3 {
    font-size: 0.78rem;
  }

  .step-content p {
    font-size: 0.64rem;
  }
}
</style>
